var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchBrandIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_5048_38275)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#paint0_angular_5048_38275)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.87551 17.8844C7.20445 19.4341 7.92122 20.4629 9.08563 21.0182C11.1719 22.0129 12.647 21.4918 14.1711 21.8067C15.6953 22.1216 16.2489 23.2579 17.4642 24.0414C18.4127 24.6529 20.6586 24.6625 21.7296 23.4517C22.7803 22.2543 23.7549 21.1498 23.3587 19.0945C22.9759 17.0594 21.5532 16.0844 21.0334 13.9512C20.5136 11.8179 20.834 10.02 19.7648 8.91766C18.6437 7.76173 15.6288 6.63599 13.5346 7.79724C11.8501 8.73129 11.552 10.8448 9.98201 11.935C8.41203 13.0252 7.7144 13.546 7.36546 14.4446C6.88306 15.6869 6.60671 16.6181 6.87551 17.8844Z",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_5048_38275",
    x: -8,
    y: -8,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_5048_38275"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_5048_38275",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_5048_38275",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21 14) rotate(-23.1586) scale(62.7207 60.6913)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.102594,
    stopColor: "#9C876E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.376547,
    stopColor: "#D99B71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.642851,
    stopColor: "#CDAA7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822998,
    stopColor: "#C7976E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998567,
    stopColor: "#887764"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBrandIcon);
export default __webpack_public_path__ + "static/media/search-brand-icon.b48264c06919bfb51b98891a1ba6b09d.svg";
export { ForwardRef as ReactComponent };